import { Injectable } from '@angular/core'
import { NzMessageService } from 'ng-zorro-antd/message';
import { ApiService } from '../services/api.service';
import {
    AdvancePayment,
    AdvancePaymentResponseModel,
    CityResponseModel, CountryResponseModel, EventDashboardStatsModel, EventMasterDashboardStatsModel, EventModel,
    EventNoteResponseModel, EventResponseModel, InvoiceResponseModel, Payment, PaymentResponseModel, QuotationResponseModel,
    StandardResponseModel, StateResponseModel,
    SafetyModel,SafetyListResponse,
    VendortaxResponseModel,FeedbackResponseModel,LicenseTypeResponseModel
} from '../models/event.model';
import { BehaviorSubject, Observer, Subscription } from 'rxjs';
import { ApiServiceDelegate } from '../models/api-service-delegate';
import { ApiCollection } from '../providers/api-collection';
import { UserResponseModel } from '../models/user.model';
import { PriorityResponseModel, TaskResponseModel, TaskStatusResponseNodel, Timezone, TimezonResponseModel, UserGroupResponseModel } from '../models/task.model';
import { EventDrawerComponent } from '../components/event-drawer/event-drawer.component';
import { EventDashboardComponent } from '../pages/events/event-dashboard/event-dashboard.component';
import { EventListComponent } from '../pages/events/event-list/event-list.component';
import { EventDetailComponent } from '../pages/events/event-detail/event-detail.component';
import { CetOutsourcingComponent } from '../components/console-event-tab/cet-outsourcing/cet-outsourcing.component';
import { OutsourcingFormResponseModel, OutsourcingRequestResponseModel, OutsourcingTypeResponseModel } from '../models/outsourcing.model';
import { ProjectResponseModel } from '../models/project.model';
import { ConsoleEventTabComponent } from '../components/console-event-tab/console-event-tab.component';
import { CetTasksComponent } from '../components/console-event-tab/cet-tasks/cet-tasks.component';
import { CetDashboardComponent } from '../components/console-event-tab/cet-dashboard/cet-dashboard.component';
import { CetNotesComponent } from '../components/console-event-tab/cet-notes/cet-notes.component';
import { CetQuotationsComponent } from '../components/console-event-tab/cet-quotations/cet-quotations.component';
import { CetInvoicesComponent } from '../components/console-event-tab/cet-invoices/cet-invoices.component';
import { CetPaymentsComponent } from '../components/console-event-tab/cet-payments/cet-payments.component';
import { CetInquiryComponent } from '../components/console-event-tab/cet-inquiry/cet-inquiry.component';
import { QuotationRequestResponseModel } from '../models/quotation.model';
import { CetVendorRequestsComponent } from '../components/console-event-tab/cet-vendor-requests/cet-vendor-requests.component';
import { OutsourcingRequestVendorModel, OutsourcingRequestVendorResponseModel, VendorModel, VendorResponseModel, VendorSubmissionAnswerReponseModel, VendorSubmissionModel, VendorSubmissionResponseModel, VendorFinancialStatsResponseModel } from '../models/vendor.model';
import { CetInquiryModalComponent } from '../components/console-event-tab/cet-inquiry/cet-inquiry-modal/cet-inquiry-modal.component';
import { CetPaymentModalComponent } from '../components/console-event-tab/cet-payments/cet-payment-modal/cet-payment-modal.component';
import { CetInvoicesModalComponent } from '../components/console-event-tab/cet-invoices/cet-invoices-modal/cet-invoices-modal.component';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { VendorRequestModalComponent } from '../components/console-event-tab/cet-vendor-requests/vendor-request-modal/vendor-request-modal.component';
import { CetPaymentsDetailsComponent } from '../components/cet-payments-details/cet-payments-details.component';
import { CetInvoiceDetailsComponent } from '../components/cet-invoice-details/cet-invoice-details.component';
import { CetVendorDetailsComponent } from '../components/console-event-tab/cet-vendor-details/cet-vendor-details.component';
import { VendorSubmissionModalComponent } from '../components/vendor-submission-modal/vendor-submission-modal.component';
import { OutsourcingFormQuestionResponseModel, OutsourcingFormSectionResponseModel } from '../models/outsourcing-form.model';
import { CompareQuotationsComponent } from '../components/console-event-tab/compare-quotations/compare-quotations.component';
import { AdvancedPaymentsComponent } from '../components/console-event-tab/advanced-payments/advanced-payments.component';
import { AddAdvancePaymentComponent } from '../components/console-event-tab/advanced-payments/add-advance-payment/add-advance-payment.component';
import { StanderedResponseModel } from '../models/standered.model';
import { AdvancedPaymentDetailsComponent } from '../components/advanced-payment-details/advanced-payment-details.component';
import { GenarateClientPptComponent } from '../components/console-event-tab/genarate-client-ppt/genarate-client-ppt.component';
import { CetComplianceSafetyComponent } from '../components/console-event-tab/cet-compliance-safety/cet-compliance-safety.component';


@Injectable({
    providedIn: 'root'
})

export class EventViewModel {
    constructor(private apiService: ApiService, private message: NzMessageService) {
    }
    eventDrawerComponent: EventDrawerComponent
    eventDashboardComponent: EventDashboardComponent
    eventListComponent: EventListComponent
    eventDetailComponent: EventDetailComponent
    consoleEventTabComponent: ConsoleEventTabComponent
    parentCetOutsourcingComponent: CetOutsourcingComponent;
    cetTasksComponent: CetTasksComponent;
    parentCetDashboardComponent: CetDashboardComponent;
    parentCetNotesComponent: CetNotesComponent;
    cetQuotationsComponent: CetQuotationsComponent
    cetInvoicesComponent: CetInvoicesComponent
    cetPaymentsComponent: CetPaymentsComponent;
    parentCetInquiryComponent: CetInquiryComponent;
    cetPaymentModalComponent: CetPaymentModalComponent;
    cetInvoicesModalComponent: CetInvoicesModalComponent;
    parentCetVendorRequestsComponent: CetVendorRequestsComponent;
    parentCetInquiryModalComponent: CetInquiryModalComponent;
    parentVendorRequestModalComponent: VendorRequestModalComponent;
    cetPaymentsDetailsComponent: CetPaymentsDetailsComponent
    cetInvoiceDetailsComponent: CetInvoiceDetailsComponent
    cetVendorDetailsComponent: CetVendorDetailsComponent
    parentVendorSubmissionModalComponent: VendorSubmissionModalComponent;
    parentCompareQuotationsComponent: CompareQuotationsComponent;
    advancedPaymentsComponent:AdvancedPaymentsComponent
    addAdvancePaymentComponent:AddAdvancePaymentComponent
    vendorSubmissionModalComponent:VendorSubmissionModalComponent
    advancedPaymentDetailsComponent:AdvancedPaymentDetailsComponent;
    parentGenarateClientPptComponent: GenarateClientPptComponent;
    parentSafetyComponent:CetComplianceSafetyComponent
    private advancePaymentsInFlightKey: string | null = null;
    private vendorFinancialStatsInFlightKey: string | null = null;
    // cetComplianceSafety : CetComplianceSafetyComponent;

    paymentType = new BehaviorSubject<StanderedResponseModel>(new StanderedResponseModel())
    eventFormatType = new BehaviorSubject<StanderedResponseModel>(new StanderedResponseModel())
    taskStatusList = new BehaviorSubject<TaskStatusResponseNodel>(new TaskStatusResponseNodel())
    eventResponseModel = new BehaviorSubject<EventResponseModel>(new EventResponseModel())
    userGroupList = new BehaviorSubject<UserGroupResponseModel>(new UserGroupResponseModel())
    userList = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    currencyList = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    budgetTypeList = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    eventTypeList = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    statusTypeList = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    industryList = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
    countryList = new BehaviorSubject<CountryResponseModel>(new CountryResponseModel());
    stateList = new BehaviorSubject<StateResponseModel>(new StateResponseModel());
    cityList = new BehaviorSubject<CityResponseModel>(new CityResponseModel());
    eventModel = new BehaviorSubject<EventModel>(new EventModel())
    projectListData = new BehaviorSubject<ProjectResponseModel>(new ProjectResponseModel());
    taskDataList = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel())
    priorityList = new BehaviorSubject<PriorityResponseModel>(new PriorityResponseModel())
    outsourcingRequestResponseModel = new BehaviorSubject<OutsourcingRequestResponseModel>(new OutsourcingRequestResponseModel());
    outsourcingTypeResponseModel = new BehaviorSubject<OutsourcingTypeResponseModel>(new OutsourcingTypeResponseModel());
    outsourcingFormResponseModel = new BehaviorSubject<OutsourcingFormResponseModel>(new OutsourcingFormResponseModel());
    quotationResponseModel = new BehaviorSubject<QuotationResponseModel>(new QuotationResponseModel());
    invoiceResponseModel = new BehaviorSubject<InvoiceResponseModel>(new InvoiceResponseModel())
    invoiceDetailsResponseModel = new BehaviorSubject<InvoiceResponseModel>(new InvoiceResponseModel())
    paymentResponseModel = new BehaviorSubject<PaymentResponseModel>(new PaymentResponseModel())
    advancePaymentResponseModel = new BehaviorSubject<AdvancePaymentResponseModel>(new AdvancePaymentResponseModel())
    paymentDetailsModel = new BehaviorSubject<Payment>(new Payment())
    vendorResponseModel = new BehaviorSubject<VendorResponseModel>(new VendorResponseModel())
    timezone = new BehaviorSubject<TimezonResponseModel>(new TimezonResponseModel())
    advancePaymentDetailsModel = new BehaviorSubject<AdvancePayment>(new AdvancePayment())
    vendorTaxResponseModel = new BehaviorSubject<VendortaxResponseModel>(new VendortaxResponseModel())
    eventDashboardStatsModel = new BehaviorSubject<EventDashboardStatsModel>(
        new EventDashboardStatsModel()
    );
    eventMasterDashboardStatsModel = new BehaviorSubject<EventMasterDashboardStatsModel>(new EventMasterDashboardStatsModel());

    eventNoteResponseModel = new BehaviorSubject<EventNoteResponseModel>(
        new EventNoteResponseModel()
    );

    quotationRequestResponseModel = new BehaviorSubject<QuotationRequestResponseModel>(new QuotationRequestResponseModel());
    outsourcingRequestVendorModel = new BehaviorSubject<OutsourcingRequestVendorResponseModel>(
        new OutsourcingRequestVendorResponseModel()
    );
    outsourcingRequestVendorDetailModel = new BehaviorSubject<VendorModel>(
        new VendorModel()
    );
    outsourcingFormsResponseModel = new BehaviorSubject<OutsourcingFormResponseModel>(new OutsourcingFormResponseModel());

    vendorSubmissionModel = new BehaviorSubject<VendorSubmissionModel>(
        new VendorSubmissionModel()
    );

    vendorSubmissionAnswerReponseModel = new BehaviorSubject<VendorSubmissionAnswerReponseModel>(
        new VendorSubmissionAnswerReponseModel()
    );

    outsourcingFormSectionResponseModel = new BehaviorSubject<OutsourcingFormSectionResponseModel>(
        new OutsourcingFormSectionResponseModel()
    );

    outsourcingFormQuestionResponseModel = new BehaviorSubject<OutsourcingFormQuestionResponseModel>(
        new OutsourcingFormQuestionResponseModel()
    );

      safetyListResponse = new BehaviorSubject<SafetyListResponse>(new SafetyListResponse());


     subscribeToSafetyResponse(subject: BehaviorSubject<SafetyListResponse>) {
        this.safetyListResponse = subject;
      }

    feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());
    feedbackVendorResponseModel = new BehaviorSubject<any>({ results: [] });

    // Vendor financial stats
    vendorFinancialStatsResponseModel = new BehaviorSubject<VendorFinancialStatsResponseModel>(new VendorFinancialStatsResponseModel());


      licenseTypeResponseModel = new BehaviorSubject<LicenseTypeResponseModel>(new LicenseTypeResponseModel());

  subscribeToLicenseType(observer: Observer<LicenseTypeResponseModel>) {
    this.licenseTypeResponseModel.subscribe(observer);
  }


    subscribeToVendorSubmission(
        observer: Observer<VendorSubmissionModel>,
        observerSection: Observer<OutsourcingFormSectionResponseModel>,
        observerQuestion: Observer<OutsourcingFormQuestionResponseModel>,
        observerAnswer: Observer<VendorSubmissionAnswerReponseModel>,

    ) {
        this.vendorSubmissionModel.subscribe(observer);
        this.outsourcingFormSectionResponseModel.subscribe(observerSection);
        this.outsourcingFormQuestionResponseModel.subscribe(observerQuestion);
        this.vendorSubmissionAnswerReponseModel.subscribe(observerAnswer);
    }

    subscribeToOutSourcingForms(observer: Observer<OutsourcingFormResponseModel>) {
        this.outsourcingFormsResponseModel.subscribe(observer);
    }

    vendorSubmissionResponseModel = new BehaviorSubject<VendorSubmissionResponseModel>(
        new VendorSubmissionResponseModel()
    );

    subscribeToVendors(observer: Observer<VendorResponseModel>) {
        this.vendorResponseModel.subscribe(observer);
    }

    subscribeToVendorsRequests(
        observer: Observer<VendorSubmissionResponseModel>

    ) {
        this.vendorSubmissionResponseModel.subscribe(observer);
    }
    subscribeToPaymentDetails(observer: Observer<Payment>) {
        this.paymentDetailsModel.subscribe(observer);
    }
    subscribeToAdvancePaymentDetails(observer: Observer<AdvancePayment>) {
        this.advancePaymentDetailsModel.subscribe(observer);
    }




    subscribeToRFQ(observer: Observer<OutsourcingRequestVendorResponseModel>) {
        this.outsourcingRequestVendorModel.subscribe(observer);
    }
    subscribeToRFQDetails(observer: Observer<VendorModel>) {
        this.outsourcingRequestVendorDetailModel.subscribe(observer);
    }

    subscribeToQuotationRequest(observer: Observer<QuotationRequestResponseModel>) {
        this.quotationRequestResponseModel.subscribe(observer);
    }

    subscribeToEventNote(observer: Observer<EventNoteResponseModel>) {
        this.eventNoteResponseModel.subscribe(observer);
    }

    subscribeMasterDashboard(observer: Observer<EventMasterDashboardStatsModel>) {
        this.eventMasterDashboardStatsModel.subscribe(observer);
    }

    subscribeToDashboardStats(observer: Observer<EventDashboardStatsModel>) {
        this.eventDashboardStatsModel.subscribe(observer);
    }

    subscribeToOutSourcingTypes(
        observer: Observer<OutsourcingTypeResponseModel>

    ) {
        this.outsourcingTypeResponseModel.subscribe(observer);
    }

    subscribeToQuotation(
        observer: Observer<QuotationResponseModel>
    ) {
        this.quotationResponseModel.subscribe(observer);
    }



    subscribeToOutsourcingForm(
        observer: Observer<OutsourcingFormResponseModel>
    ) {
        this.outsourcingFormResponseModel.subscribe(observer);
    }

    subscribeToInvoice(
        observer: Observer<InvoiceResponseModel>
    ) {
        this.invoiceResponseModel.subscribe(observer);
    }
    subscribeToInvoiceDetails(
        observer: Observer<InvoiceResponseModel>
    ) {
        this.invoiceDetailsResponseModel.subscribe(observer);
    }
    subscribeToPayment(
        observer: Observer<PaymentResponseModel>
    ) {
        this.paymentResponseModel.subscribe(observer);
    }
    subscribeToAdvancePayment(
        observer: Observer<AdvancePaymentResponseModel>
    ) {
        this.advancePaymentResponseModel.subscribe(observer);
    }

    subscribeToOutSourcingEventRequest(observer: Observer<OutsourcingRequestResponseModel>) {
        this.outsourcingRequestResponseModel.subscribe(observer);
    }

    subscribeToEventResponse(observer: Observer<EventResponseModel>) {
        this.eventResponseModel.subscribe(observer)
    }
    subscribeToEventDetail(observer: Observer<EventModel>) {
        this.eventModel.subscribe(observer)
    }
    subscribeToProjectTask(observer: Observer<TaskResponseModel>) {
        this.taskDataList.subscribe(observer)
    }



    subscribeToFeedback(observer: Observer<FeedbackResponseModel>) {
      this.feedbackResponseModel.subscribe(observer);
    }

    subscribeFeedbackVendorResponseModel(observer: Observer<any>) {
      this.feedbackVendorResponseModel.subscribe(observer);
    }

        // Subscribe method for vendor financial stats
        subscribeToVendorFinancialStats(observer: Observer<VendorFinancialStatsResponseModel>) {
                this.vendorFinancialStatsResponseModel.subscribe(observer);
        }

    /**
  * Helper function to format backend validation errors for display.
  * @param errors The error object from the backend.
  * @returns A string containing formatted error messages.
  */
    private formatBackendErrors(errors: any): void {
        let errorMessages = '';
        if (typeof errors === 'object') {
            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    errorMessages += `<strong>${key}:</strong> ${Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]}<br>`;
                }
            }
        } else {
            errorMessages = errors.toString();
        }
        this.message.error(errorMessages, { nzDuration: 1500 });
        // return errorMessages;
    }

    getCountryList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Country + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.countryList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getStateListById(page: number, page_size: number, id?: number,name?:string) {
        let url = ApiCollection.State + '?page=' + page + '&page_size=' + page_size
        if (id) {
            url += '&country=' + id
        }
        if(name){
            url += '&name=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.stateList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getCityListById(page: number, page_size: number, state?: number, name?:string) {
        let url = ApiCollection.City + '?page=' + page + '&page_size=' + page_size
        if(state){
            url += '&state=' + state
        }
        if(name){
            url += '&name=' + name
        }
        // console.log(url)
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:url,
            Success: (e: any) => {
                this.cityList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getUserList(page: number, page_size: number, name?: string, user_group?: number) {
        let url = ApiCollection.User + '?page=' + page + '&page_size=' + page_size + '&is_deleted=false'
        if (name) {
            url += '&name=' + name
        }
        if (user_group) {
            url += '&user_group=' + user_group
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.userList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getUserGroupList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.User_group + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.userGroupList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    getCurrencyList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Currency + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.currencyList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    getBudgetTypeList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Budget_Type + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.budgetTypeList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    getEventTypeList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Event_Type + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.eventTypeList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }
    // New: filtered event type list based on event format flags (in-person/virtual)
    getEventTypeListFiltered(
        page: number,
        page_size: number,
        opts?: { is_inperson?: boolean; is_virtual?: boolean }
    ) {
    // Use the new v2 endpoint specifically for filtered queries
    let url = ApiCollection.Event_Type_V2 + '?page=' + page + '&page_size=' + page_size;
        if (opts?.is_inperson) {
            url += '&is_inperson=true';
        }
        if (opts?.is_virtual) {
            url += '&is_virtual=true';
        }

        const d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: url,
            Success: (e: any) => {
                this.eventTypeList.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            }
        };
        this.apiService.callService(d);
    }
    getEventStatusList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Event_Status + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.statusTypeList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }



    createEvent(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Event,
            Success: (e: any) => {
                this.message.success("Event created successfully", { nzDuration: 1000 });
                this.eventDrawerComponent.eventCreated(e)
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Event creation unsuccessfully", { nzDuration: 1000 });
                this.formatBackendErrors(e)
                // this.eventDrawerComponent.closeonly()
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createVendorProduct(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Submission_Product,
            Success: (e: any) => {
                // this.message.success("Vendor Product created successfully", { nzDuration: 1000 });
                this.vendorSubmissionModalComponent.productCreated(e)
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Event creation unsuccessfully", { nzDuration: 1000 });
                this.formatBackendErrors(e)
                // this.eventDrawerComponent.closeonly()
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateVendorProduct(data: any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Submission_Product + '/' + data.id,
            Success: (e: any) => {
                // this.message.success("Vendor Product update successfully", { nzDuration: 1000 });
                this.vendorSubmissionModalComponent.formUpdated()
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Event creation unsuccessfully", { nzDuration: 1000 });
                this.formatBackendErrors(e)
                // this.eventDrawerComponent.closeonly()
                return e;
            },
        };
        this.apiService.callService(d);
    }

      deleteVendorProduct(data: any,index) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Submission_Product + '/' + data.id,
            Success: (e: any) => {
                this.message.success("Vendor Product deleted successfully", { nzDuration: 1000 });
                this.vendorSubmissionModalComponent.productDeleted(index)
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Event creation unsuccessfully", { nzDuration: 1000 });
                this.formatBackendErrors(e)
                // this.eventDrawerComponent.closeonly()
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getEvents(page: number, page_size: number, caller: string, name?: string,status?: number, sort_type?: string, event_type?: number[]) {
        // console.log("sort_type ::",sort_type)
        let src = ApiCollection.Event + '?page=' + page + '&page_size=' + page_size +  '&sort_by=start_datetime';
        if (name?.length > 0) {
            src += '&event_name=' + name
        }
        if (status > 0 || status!= null ) {
            src += '&status=' + status
        }
        if (event_type?.length > 0) {
            src += '&event_type=' + event_type.join(',')
        }
        // if (sort_type?.length > 0) {
        //     src += '&sort_type=' + sort_type
        // }
        src += '&sort_type=desc'
        // sort_type=desc or aesc, sort_by=model field name

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.eventResponseModel.next(e)
                if (caller == 'eventDashboardComponent') {
                    this.eventDashboardComponent.eventdataRecieved()
                }
                if (caller == 'eventlistComponent') {
                    this.eventListComponent.eventListdataRecieved()
                }
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTimezoneList(name: string = '') {
        let src = ApiCollection.Timezone + '?page=1&page_size=200' ;
        if (name.length > 0) {
            src += '&name=' + name;
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.timezone.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

     getPaymentType() {
        let src = ApiCollection.Payment_Type + '?page=1&page_size=10' ;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: src,
            Success: (e: any) => {
                this.paymentType.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }





    getQuotation(page: number, page_size: number, caller: string, eventId?: any) {
        let str = ApiCollection.Quotation + '?page=' + page + '&page_size=' + page_size;
        if (eventId) {
            str += '&event=' + eventId
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.quotationResponseModel.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getInvoices(page: number, page_size: number, caller: string, eventId?: any, name?:string) {
        let str = ApiCollection.Invoice + '?page=' + page + '&page_size=' + page_size
        if (eventId != null) {
            str += '&event=' + eventId
        }
        if(name){
            str += '&search=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.invoiceResponseModel.next(e)
                if (caller == 'cetInvoicesComponent') {
                    this.cetInvoicesComponent.invoiceRecieved()
                }

                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    getInvoiceDetails(id: number) {
        let str = ApiCollection.Invoice + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.invoiceDetailsResponseModel.next(e)

                this.cetInvoiceDetailsComponent.invoiceDetailsRecieved()


                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateInvoiceDetails(data: any) {
        let str = ApiCollection.Invoice + '/' + data.id;

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: str,
            Success: (e: any) => {
                this.cetInvoicesModalComponent.invoiceDetailsupdated();
                return e;
            },
            Error: (e: String) => {
                this.cetInvoicesModalComponent?.invoiceDetailsUpdateFailed?.();
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteInvoiceDetails(id: number) {
        let str = ApiCollection.Invoice + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: str,
            Success: (e: any) => {
                this.message.success("Invoice deleted successfully", { nzDuration: 1000 });
                this.cetInvoicesComponent.invoiceDeleted()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    createInvoices(data: any) {

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Invoice,
            Success: (e: any) => {
                this.cetInvoicesModalComponent.handleModalCancel()
                return e;
            },
            Error: (e: String) => {
                this.cetInvoicesModalComponent?.invoiceDetailsUpdateFailed?.();
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createVendorRequest(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.OutsourcingRequestVendor,
            Success: (e: any) => {
                this.parentVendorRequestModalComponent.vendorRequestCreated();
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e);
                this.parentVendorRequestModalComponent.failedToCreate();
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateVendorRequest(payload: any, Id:any) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.OutsourcingRequestVendor + '/' + Id,
            Success: (e: any) => {
                this.parentVendorRequestModalComponent.vendorRequestCreated()
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteVendorRequest(id: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.OutsourcingRequestVendor + '/' + id,
            Success: (e: any) => {
                this.parentCetVendorRequestsComponent.requestDeleted()
                return e;
            },
            // Error: (e: String) => {

            //     return e;
            // },
             Error: (e: any) => {
                const errorMsg = e?.error || 'Delete failed. Please try again.';
                this.message.error(errorMsg, { nzDuration: 3000 });
                return e;
                // return e;
            },
        };
        this.apiService.callService(d);
    }

    getVendorSubmissions(page: number, page_size: number, eventId?: any,name?: string, caller?:string, is_shortlisted?: boolean) {
        let str = ApiCollection.VendorSubmission + '?page=' + page + '&page_size=' + page_size;

        // console.log("page ::",page);
        // console.log("page_size ::",page_size);
        // console.log("eventId ::",eventId);
        // console.log("name ::",name);

        // console.log("caller ::",caller);

        if(name){
            str += '&search=' + name
        }
        if (eventId) {
            str += '&event=' + eventId
        }

        if(is_shortlisted != null){
            str += '&is_shortlisted=' + is_shortlisted
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                if(caller == 'cetQuotationsComponent' ){
                    this.vendorSubmissionResponseModel.next(e);
                    this.cetQuotationsComponent.vendorRequestRecieved()
                }
                if(caller == 'cet-invoices-modal'){
                    this.cetInvoicesModalComponent.vendorSubmissionsReceived(e)
                }
                if(caller == 'advancedPaymentsComponent'){
                //   console.log("e ::",e)
                    this.vendorSubmissionResponseModel.next(e);
                    // this.cetQuotationsComponent.vendorRequestRecieved()
                }

                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVendorTaxList() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Tax,
            Success: (e: any) => {
                this.vendorTaxResponseModel.next(e)
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVendorSubmissionByID(submissionId?: number,) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.VendorSubmission + '/' + submissionId?.toString(),
            Success: (e: any) => {
                this.vendorSubmissionModel.next(e)
                this.parentVendorSubmissionModalComponent.vendorSubmissionRecieved();
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateVendorSubmissionByID(data:any,submissionId?: number) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.VendorSubmission + '/' + submissionId?.toString(),
            Success: (e: any) => {
                this.vendorSubmissionModalComponent.formUpdated()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getconvertedCurrency(from_currency: string, to_currency: string,caller:string) {

      if(!from_currency){
            console.log("Unable to convert currency as from currency is not provided from caller: ", caller)
            return;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.CurrencyConverter.replace('{FROM_CURRENCY}',from_currency).replace('{TO_CURRENCY}',to_currency),
            Success: (e: any) => {
                if(caller == 'vendorSubmissionModalComponent'){
                this.vendorSubmissionModalComponent.convertedCurrencyRecieved(e);
                }
                if(caller == 'addAdvancePaymentComponent') {
                    this.addAdvancePaymentComponent.convertedCurrencyRecieved(e);
                }
                if(caller == 'addinvoice') {
                    this.cetInvoicesModalComponent.convertedCurrencyRecieved(e);
                }
                if(caller == 'event-drawer'){
                    this.eventDrawerComponent.convertedCurrencyRecieved(e);
                }
                if(caller == 'compliance-safety'){
                    this.parentSafetyComponent.convertedCurrencyRecieved(e);
                }
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateOutsourcingRequestVendor(payload: any,id:any, type: 'Shortlisted' | 'Finalized', caller: string) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.OutsourcingRequestVendor + '/' + id?.toString(),
            Success: (e: any) => {

                if (caller == 'compare-quotations') {
                    this.parentCompareQuotationsComponent.vendorSubmissionUpdated(type, payload);
                }

                if (caller == 'vendor-submission-modal') {
                    this.parentVendorSubmissionModalComponent.vendorSubmissionUpdated(type);
                }

                this.message.success("Submission updated successfully!", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVendorAnswars(page: number, page_size: number, submissionId: any, caller: string) {
        let url = ApiCollection.VendorAnswer + '?page=' + page + '&page_size=' + page_size + '&submission=' + submissionId;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                if (caller == 'vendor-submission-modal') {
                    this.vendorSubmissionAnswerReponseModel.next(e)
                    this.parentVendorSubmissionModalComponent.vendorAnswersRecieved();
                }

                if(caller == 'compare-quotations'){
                    this.parentCompareQuotationsComponent.vendorAnswersRecieved(e, submissionId);
                }

                if(caller == 'genarate-client-ppt'){
                    this.parentGenarateClientPptComponent.vendorAnswersRecieved(e, submissionId);
                }


                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getSections(id: string, caller: string, dataIndex?: number) {
        const url = ApiCollection.OutsourcingFormSection + "?page=1&page_size=100" + '&outsourcing_form=' + id;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                if (caller == 'vendor-submission-modal') {
                    this.outsourcingFormSectionResponseModel.next(e);
                    this.parentVendorSubmissionModalComponent.sectionsDataReceived();
                }

                if (caller == 'compare-quotations') {
                    this.parentCompareQuotationsComponent.sectionsDataReceived(e, dataIndex);
                }

                // if (caller == 'genarate-client-ppt') {
                //     this.parentGenarateClientPptComponent.sectionsDataReceived(e, dataIndex);
                // }

                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getOSQuestions(ids: string, caller: string, dataIndex?: number) {
        const url = ApiCollection.OutsourcingFormQuestion + "?page=1&page_size=100" + '&section=' + ids;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                if (caller == 'vendor-submission-modal') {
                    this.outsourcingFormQuestionResponseModel.next(e);
                    this.parentVendorSubmissionModalComponent.questionsDataReceived();
                }

                if (caller == 'compare-quotations') {
                    this.parentCompareQuotationsComponent.questionsDataReceived(e, dataIndex);
                }

                // if(caller == 'genarate-client-ppt'){
                //     this.parentGenarateClientPptComponent.questionsDataReceived(e, dataIndex);
                // }
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getQuotationRequest(page: number, page_size: number, eventId: any, caller: string, search?: string) {
        let str = ApiCollection.QuotationRequest + '?page=' + page + '&page_size=' + page_size
        if (eventId) {
            str += '&event=' + eventId
        }
        if (search) {
            str += '&search=' + search
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.quotationRequestResponseModel.next(e);
                if (caller == 'cet-inquiry') {
                    this.parentCetInquiryComponent.inquaryRecieved()
                }
                if (caller == 'vendor-request-modal') {
                    this.parentVendorRequestModalComponent.vendorRequestRecieved()
                }
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    deleteQuotationRequest(id: number) {
        let str = ApiCollection.QuotationRequest + '/' + id

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: str,
            Success: (e: any) => {

                this.parentCetInquiryComponent.inqueryDeleted()

                return e;
            },
            Error: (e: any) => {
                const errorMsg = e?.error || 'Delete failed. Please try again.';
                this.message.error(errorMsg, { nzDuration: 3000 });
                return e;
                // return e;
            },
        };
        this.apiService.callService(d);
    }
    updateQuotationRequest(data: any) {
        let str = ApiCollection.QuotationRequest + '/' + data.id

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: str,
            Success: (e: any) => {

                this.parentCetInquiryModalComponent.QuotationRequestCreated()
                this.message.success("Quotation request updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getOutsourcingRequestVendor(page: number, page_size: number, eventId: any, search?: string) {
        let str = ApiCollection.OutsourcingRequestVendor + '?page=' + page + '&page_size=' + page_size
        if (eventId) {
            str += '&event=' + eventId
        }
        if (search) {
            str += '&search=' + search
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.outsourcingRequestVendorModel.next(e);
                this.parentCetVendorRequestsComponent.outsourcingRequestVendorRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    getOutsourcingRequestVendorDetails(id: any) {
        let str = ApiCollection.Vendor + '/' + id

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.outsourcingRequestVendorDetailModel.next(e);
                this.cetVendorDetailsComponent.outsourcingRequestVendorDetailsRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }


    getPayments(page: number, page_size: number, eventId: any, name?:string) {
        let str = ApiCollection.Payment + '?page=' + page + '&page_size=' + page_size;
        if (eventId) {
            str += '&event=' + eventId
        }
        if(name){
            str += '&search=' + name
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.paymentResponseModel.next(e)
                this.cetPaymentsComponent.paymentRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    getadvancePayments(page: number, page_size: number, eventId: any, name?:string,vendorId ?: any) {
        let str = ApiCollection.AdvancePayment + '?page=' + page + '&page_size=' + page_size;
        if (eventId) {
            str += '&event=' + eventId
        }
        if(name){
            str += '&search=' + name
        }
        if(vendorId){
            str += '&vendor=' + vendorId
        }

        if (this.advancePaymentsInFlightKey === str) {
            return;
        }
        this.advancePaymentsInFlightKey = str;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.advancePaymentsInFlightKey = null;
                this.advancePaymentResponseModel.next(e)
                this.advancedPaymentsComponent.paymentRecieved()
                return e;
            },
            Error: (e: String) => {
                this.advancePaymentsInFlightKey = null;

                return e;
            },
        };
        this.apiService.callService(d);
    }

    // Fetch vendor financial statistics (optionally scoped by event)
    getVendorFinancialStats(eventId?: any) {
        let str = ApiCollection.Vendor_Financial_Stats as string;
        // Add event filter if provided
        if (eventId) {
            // append as query param
            const sep = str.includes('?') ? '&' : '?';
            str = `${str}${sep}event=${eventId}`;
        }

        if (this.vendorFinancialStatsInFlightKey === str) {
            return;
        }
        this.vendorFinancialStatsInFlightKey = str;

        const d: ApiServiceDelegate = {
            Data: {},
            Method: 'GET',
            Action: str,
            Success: (e: any) => {
                this.vendorFinancialStatsInFlightKey = null;
                this.vendorFinancialStatsResponseModel.next(e);
                // Notify component if present
                if (this.advancedPaymentsComponent && typeof (this.advancedPaymentsComponent as any).vendorStatsReceived === 'function') {
                    (this.advancedPaymentsComponent as any).vendorStatsReceived();
                }
                return e;
            },
            Error: (err: any) => {
                this.vendorFinancialStatsInFlightKey = null;
                return err;
            }
        };
        this.apiService.callService(d);
    }

    getPaymentById(id: any) {
        let str = ApiCollection.Payment + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.paymentDetailsModel.next(e)
                this.cetPaymentsDetailsComponent.paymentDetailRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    getAdvancePaymentById(id: any) {
        let str = ApiCollection.AdvancePayment + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: str,
            Success: (e: any) => {
                this.advancePaymentDetailsModel.next(e)
                this.advancedPaymentDetailsComponent.paymentDetailRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteAdvancePaymentById(id: any) {
        let str = ApiCollection.AdvancePayment + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: str,
            Success: (e: any) => {
                this.advancedPaymentsComponent.paymentDeleted()
                this.message.success("Payment deleted successfully", { nzDuration: 1000 });
                // Refresh Vendor Overview graph and table after deletion
                try {
                    const eventId = this.advancedPaymentsComponent?.eventId;
                    this.getVendorFinancialStats(eventId);
                } catch {}
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    deletePaymentById(id: any) {
        let str = ApiCollection.Payment + '/' + id;

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: str,
            Success: (e: any) => {
                this.cetPaymentsComponent.paymentDeleted()
                this.message.success("Payment deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    updatePaymentById(data: any) {
        let str = ApiCollection.Payment + '/' + data.id;

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: str,
            Success: (e: any) => {
                this.message.success("Payment updated successfully", { nzDuration: 1000 });
                this.cetPaymentModalComponent.handleModalCancel()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    updateAdvancePaymentById(data: any) {
        let str = ApiCollection.AdvancePayment + '/' + data.id;

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: str,
            Success: (e: any) => {
                if (this.addAdvancePaymentComponent && typeof (this.addAdvancePaymentComponent as any).onAdvancePaymentUpdateSuccess === 'function') {
                    (this.addAdvancePaymentComponent as any).onAdvancePaymentUpdateSuccess(e);
                    return e;
                }

                this.message.success("Payment updated successfully", { nzDuration: 1000 });
                this.addAdvancePaymentComponent.handleModalCancel()
                // Refresh Payment List and Vendor Overview after update
                try {
                    if (this.advancedPaymentsComponent && typeof (this.advancedPaymentsComponent as any).getData === 'function') {
                        (this.advancedPaymentsComponent as any).getData();
                    }
                    const eventId = this.advancedPaymentsComponent?.eventId;
                    this.getVendorFinancialStats(eventId);
                } catch {}
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    createPayments(data: any) {

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.Payment,
            Success: (e: any) => {
                this.cetPaymentModalComponent.handleModalCancel()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }
    createAdvancePayments(data: any) {

        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.AdvancePayment,
            Success: (e: any) => {
                if (this.addAdvancePaymentComponent && typeof (this.addAdvancePaymentComponent as any).onAdvancePaymentCreateSuccess === 'function') {
                    (this.addAdvancePaymentComponent as any).onAdvancePaymentCreateSuccess(e);
                    return e;
                }

                this.addAdvancePaymentComponent.handleModalCancel()
                this.message.success("Payment created successfully", { nzDuration: 1000 });
                // Refresh Payment List and Vendor Overview after creation
                try {
                    if (this.advancedPaymentsComponent && typeof (this.advancedPaymentsComponent as any).getData === 'function') {
                        (this.advancedPaymentsComponent as any).getData();
                    }
                    const eventId = this.advancedPaymentsComponent?.eventId;
                    this.getVendorFinancialStats(eventId);
                } catch {}
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    createPaymentTransaction(data: any, onSuccess?: (e: any) => void, onError?: (e: any) => void) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.PaymentTransaction,
            Success: (e: any) => {
                if (onSuccess) {
                    onSuccess(e);
                }
                return e;
            },
            Error: (e: String) => {
                if (onError) {
                    onError(e);
                }
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updatePaymentTransactionById(id: number, data: any, onSuccess?: (e: any) => void, onError?: (e: any) => void) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.PaymentTransaction + '/' + id,
            Success: (e: any) => {
                if (onSuccess) {
                    onSuccess(e);
                }
                return e;
            },
            Error: (e: String) => {
                if (onError) {
                    onError(e);
                }
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getPaymentTransactionById(id: number, onSuccess?: (e: any) => void, onError?: (e: any) => void) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.PaymentTransaction + '/' + id,
            Success: (e: any) => {
                if (onSuccess) {
                    onSuccess(e);
                }
                return e;
            },
            Error: (e: String) => {
                if (onError) {
                    onError(e);
                }
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deletePaymentTransactionById(id: number, onSuccess?: (e: any) => void, onError?: (e: any) => void) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.PaymentTransaction + '/' + id,
            Success: (e: any) => {
                if (onSuccess) {
                    onSuccess(e);
                }
                return e;
            },
            Error: (e: String) => {
                if (onError) {
                    onError(e);
                }
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getEventById(id: number, page: number, page_size: number,) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Event + '/' + id + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.eventModel.next(e)
                this.consoleEventTabComponent.eventdataRecieved()
                return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateEventById(data: any,caller:any) {

      let d: ApiServiceDelegate = {
            Data: data,
            Method: "PATCH",
            Action: ApiCollection.Event + '/' + data.id,
            Success: (e: any) => {

              if(caller=='event-drawer'){
                this.eventDrawerComponent.eventUpload()
              }

              this.message.success("Event updated successfully", { nzDuration: 1000 });
              return e;
            },
            Error: (e: String) => {

                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteEvent(id: number,) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Event + '/' + id,
            Success: (e: any) => {
                this.consoleEventTabComponent.eventDeleted();
                this.message.success("Event deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e);
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskList(page: number, page_size: number, name: string = '', filterObject: any = {}) {
        let url = ApiCollection.Task + '?page=' + page + '&page_size=' + page_size + '&sort_by=id&sort_type=desc';
        if (name.length > 0) {
            url += '&name=' + name;
        }
        for (const [key, value] of Object.entries(filterObject)) {
            if (value != null && value != undefined && value != '') {
                if (Array.isArray(value)) {
                    value.forEach(i => url += '&' + key + '=' + i)
                } else {
                    url += '&' + key + '=' + value
                }
            }
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            // Action: name ?  ApiCollection.Task +'?page='+page+'&page_size='+page_size + '&name='+name : ApiCollection.Task +'?page='+page+'&page_size='+page_size,
            Success: (e: any) => {
                this.taskDataList.next(e)
                this.cetTasksComponent.projectTaskRecieved()
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getPriorityList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Priority + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.priorityList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskStatusList(page: number, page_size: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Task_status + '?page=' + page + '&page_size=' + page_size,
            Success: (e: any) => {
                this.taskStatusList.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getOutSourcingEventRequests(outsourcing_type_name: string, page: number, page_size: number, eventId: string,
        caller: string
    ) {
        let url = ApiCollection.OutsourcingEventRequest + '?page=' + page + '&page_size=' + page_size;
        if (outsourcing_type_name) {
            url += '&outsourcing_type_name=' + outsourcing_type_name;
        }
        if (eventId) {
            url += '&event=' + eventId;
        }
        // if(caller == 'inquiry-modal'){
        //     console.log("Outsourcing Event Request URL:", url);
        // }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingRequestResponseModel.next(e);
                if (caller == 'cet-outsourcing') {
                    this.parentCetOutsourcingComponent.dataReceived();
                }

                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getOutSourcingForm(page: number, page_size: number, category?: number, caller?: string) {
        let url = ApiCollection.OutsourcingForm + '?page=' + page + '&page_size=' + page_size;
        if (category > 0) {
            url += '&category=' + category
        }

          if(caller == 'cet-inquiry-modal'){
            url += '&remove_draft=true';
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingFormResponseModel.next(e);
                if (caller == 'cet-outsourcing') {
                    this.parentCetOutsourcingComponent.outsourcingFormReceived();
                }
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                // this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getEventImage(urls: string) {
        let url = ApiCollection.EventThumbnail + urls

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.eventDrawerComponent.eventThumbnailRecieved(e);
                return e;
            },
            Error: (e: String) => {
                this.eventDrawerComponent.eventThumbnailNotRecieved()
                this.formatBackendErrors(e)
                // this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getOutSourcingTypes(page: number, page_size: number) {
        let url = ApiCollection.OutsourcingType + '?page=' + page + '&page_size=' + page_size;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingTypeResponseModel.next(e);
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createOutSourcingRequest(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.OutsourcingEventRequest,
            Success: (e: any) => {
                this.parentCetOutsourcingComponent.requestCreated();
                this.message.success("Request created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }
    updateOutSourcingRequest(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.OutsourcingEventRequest + '/' + payload['id'],
            Success: (e: any) => {
                this.parentCetOutsourcingComponent.requestCreated();
                this.message.success("Request updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteOutSourcingRequest(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.OutsourcingEventRequest + '/' + id,
            Success: (e: any) => {
                this.parentCetOutsourcingComponent.requestCreated();
                this.message.success("Request deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getEventFormatList() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.EVENT_FORMAT_TYPES,
            Success: (e: any) => {
                this.eventFormatType.next(e);
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getIndustries(name: string){
        let url = ApiCollection.INDUSTRY + '?page=1&page_size=2500'
        if (name.length > 0) {
            url += '&name=' + name
        }
         let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.industryList.next(e);
                return e;
            },
            Error: (e: String) => {
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getProjectList(page: number, page_size: number, name: string = '',) {
        let url = ApiCollection.Project + '?page=' + page + '&page_size=' + page_size + '&sort_by=id&sort_type=desc'
        if (name.length > 0) {
            url += '&name=' + name
        }

        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.projectListData.next(e)
                return e;
            },
            Error: (e: String) => {
                // this.message.success("Project loaded unsuccessfully", { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getPerEventDashboardStats(eventId: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.EventDashboardStats.replace('{EVENT_ID}', eventId?.toString()),
            Success: (e: any) => {
                this.eventDashboardStatsModel.next(e);
                this.parentCetDashboardComponent.dataReceived();
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getMasterDashboardStats() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.EventMasterDashboardStats,
            Success: (e: any) => {
                this.eventMasterDashboardStatsModel.next(e);
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getMasterDashboardEventTypeChartData() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.EventDashboardEventTypeChart,
            Success: (e: any) => {
                this.eventDashboardComponent.eventTypeChartRecieved(e);
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getMasterDashboardUpcomingEventChartData() {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.EventDashboardEventUpcomingTrendChart,
            Success: (e: any) => {
                this.eventDashboardComponent.upcomingEventChartRecieved(e);
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getEventNotes(eventId: string, name: string, page_size: number, page: number) {
        let url = ApiCollection.EventNotes + '?event=' + eventId + '&page=' + page + '&page_size=' + page_size;
        if (name.length > 0) {
            url += '&search=' + name;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.eventNoteResponseModel.next(e);
                this.parentCetNotesComponent.dataReceived();
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createEventNote(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.EventNotes,
            Success: (e: any) => {
                this.parentCetNotesComponent.noteCreated();
                this.message.success('Note created successfully', { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateEventNote(id: number, payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "PATCH",
            Action: ApiCollection.EventNotes + '/' + id,
            Success: (e: any) => {
                this.parentCetNotesComponent.noteUpdated();
                this.message.success('Note updated successfully', { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    deleteEventNote(id: number) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.EventNotes + '/' + id,
            Success: (e: any) => {
                this.parentCetNotesComponent.noteDeleted();
                this.message.success('Note deleted successfully', { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


    createQuotationRequest(payload: object) {
        let d: ApiServiceDelegate = {
            Data: payload,
            Method: "POST",
            Action: ApiCollection.QuotationRequest,
            Success: (e: any) => {
                this.parentCetInquiryModalComponent.QuotationRequestCreated();
                this.message.success('Quotation request created successfully', { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getVendors(name: string, page: number, page_size: number, caller: string, eventId?: number) {
        let url = ApiCollection.Vendor + '?page=' + page + '&page_size=' + page_size;
        if (name.length > 0) {
            url += '&search=' + name;
        }
        if (eventId) {
            url += '&event=' + eventId;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.vendorResponseModel.next(e);
                if (caller == 'vendor-request-modal') {
                    this.parentVendorRequestModalComponent.vendorRecieved();
                }
                 // Trigger callback only for specific caller
                if (caller === 'cet-notes-component') {
                   this.feedbackVendorResponseModel.next(e);
                   this.parentCetNotesComponent.vendorRecieved();
                }
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    uploadMediaFile(item: any, userId: any): Subscription {
        const formData = new FormData();
        formData.append('file', item.file as File);
        formData.append('name', item.file.name);
        formData.append('created_by', userId);

        return this.apiService.uploadFileWithProgress(ApiCollection.Media, formData).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
                    item.onProgress!({ percent: percentDone }, item.file);
                } else if (event instanceof HttpResponse) {
                    item.onSuccess!(event.body, item.file, event);
                }
            },
            error: (error) => {
                item.onError!(error, item.file);
            },
            complete: () => {
                // console.log('Upload process completed.');
            }
        });
    }

       // -------- Get List (with search + pagination) --------
  getSafetyList(name: any, page_size: number, page: number,eventId?: string) {
    let url = ApiCollection.Event_compliance + '?page=' + page + '&page_size=' + page_size + '&event=' + eventId;
    if (name !== undefined && name !== null ) {
      url += '&compliance_safety=' + name;
    }

    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'GET',
      Action: url,
      Success: (e: any) => {
        this.safetyListResponse.next(e);
        this.parentSafetyComponent.dataReceived();
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  // -------- Create --------
  createSafety(payload: any) {
    let d: ApiServiceDelegate = {
      Data: payload,
      Method: 'POST',
      Action: ApiCollection.Event_compliance,
      Success: (e: any) => {
        // console.log("resp >> create ",e)
        this.parentSafetyComponent.safetyCreated();
        this.message.success('Safety item created successfully', { nzDuration: 1000 });
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  // -------- Update --------
  updateSafety(id: number, payload: any) {
    let d: ApiServiceDelegate = {
      Data: payload,
      Method: 'PATCH',
      Action: ApiCollection.Event_compliance + '/' + id,
      Success: (e: any) => {
        this.parentSafetyComponent.safetyUpdated();
        this.message.success('Safety item updated successfully', { nzDuration: 1000 });
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

  // -------- Delete --------
  deleteSafety(id: number) {
    let d: ApiServiceDelegate = {
      Data: {},
      Method: 'DELETE',
      Action: ApiCollection.Event_compliance + '/' + id,
      Success: (e: any) => {
        this.parentSafetyComponent.safetyDeleted();
        this.message.success('Safety item deleted successfully', { nzDuration: 1000 });
        return e;
      },
      Error: (e: String) => {
        this.formatBackendErrors(e);
        return e;
      },
    };
    this.apiService.callService(d);
  }

    createFeedback(payload: object) {
      const d: ApiServiceDelegate = {
        Data: payload,
        Method: "POST",
        Action: ApiCollection.Event_vendor_feedback,
        Success: (res: any) => {
          this.parentCetNotesComponent.feedbackCreated();
          this.message.success('Feedback created successfully', { nzDuration: 1000 });
          return res;
        },
        Error: (err: string) => {
          this.formatBackendErrors(err);
          return err;
        },
      };
      this.apiService.callService(d);
    }

    updateFeedback(id: number, payload: object) {
      const d: ApiServiceDelegate = {
        Data: payload,
        Method: "PATCH",
        Action: ApiCollection.Event_vendor_feedback + '/' + id,
        Success: (res: any) => {
          this.parentCetNotesComponent.feedbackUpdated();
          this.message.success('Feedback updated successfully', { nzDuration: 1000 });
          return res;
        },
        Error: (err: string) => {
          this.formatBackendErrors(err);
          return err;
        },
      };
      this.apiService.callService(d);
    }

    deleteFeedback(id: number) {
      const d: ApiServiceDelegate = {
        Data: {},
        Method: "DELETE",
        Action: ApiCollection.Event_vendor_feedback + '/' + id,
        Success: (res: any) => {
          this.parentCetNotesComponent.feedbackDeleted();
          this.message.success('Feedback deleted successfully', { nzDuration: 1000 });
          return res;
        },
        Error: (err: string) => {
          this.formatBackendErrors(err);
          return err;
        }
      };
      this.apiService.callService(d);
    }

    getFeedbacks(eventId: string, vendorName: string = '', page_size: number = 10, page: number = 1) {
      let url = ApiCollection.Event_vendor_feedback + '?event=' + eventId + '&page=' + page + '&page_size=' + page_size;
      if (vendorName.length > 0) {
        url += '&search=' + vendorName;
      }

      const d: ApiServiceDelegate = {
        Data: {},
        Method: "GET",
        Action: url,
        Success: (res: any) => {
          this.feedbackResponseModel.next(res);
          this.parentCetNotesComponent.feedbackDataReceived();
          return res;
        },
        Error: (err: string) => {
          this.formatBackendErrors(err);
          return err;
        }
      };
      this.apiService.callService(d);
    }

   getLicenseType() {
    const d: ApiServiceDelegate = {
      Data: {},
      Method: "GET",
      Action: ApiCollection.License_type,
      Success: (res: any) => {
        this.licenseTypeResponseModel.next(res);
        this.parentSafetyComponent.liscenceRecived();
        return res;
      },
      Error: (err: string) => {
        this.formatBackendErrors(err);
        return err;
      }
    };
    this.apiService.callService(d);
  }

  updateVendorAnswer(payload: any, caller: any, answerId?: number) {
    if (caller == 'vendor-submission-modal') {
      const d: ApiServiceDelegate = {
        Data: payload,
        Method: "PATCH",
        Action: ApiCollection.VendorAnswer + '/' + answerId,
        Success: (res: any) => {
          // Call the vendor submission modal component callback with updated answer
          this.vendorSubmissionModalComponent.vendorAnswerUpdated(res);
          this.message.success('Answer updated successfully', { nzDuration: 1000 });
          return res;
        },
        Error: (err: string) => {
          this.formatBackendErrors(err);
          return err;
        },
      };
      this.apiService.callService(d);
    }
  }

}
